/* eslint-disable react/prop-types */
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  SimpleGrid,
  Textarea,
  FormErrorMessage,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

const HelpForm = ({ onHelpModalClose }) => {
  const [sendingMessage, setSendingMessage] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      message: "",
    },
  });

  // Dropdown options
  const importanceOptions = [
    { id: 1, name: "It is a time-sensitive emergency" },
    { id: 2, name: "It impacts a whole team or more" },
    { id: 3, name: "It only affects a few people" },
    { id: 4, name: "It is important but not urgent" },
  ];

  const typeOptions = [
    { id: 1, name: "New Requirement" },
    { id: 2, name: "Fix" },
    { id: 3, name: "Enhancement" },
    { id: 4, name: "Data Source to be added" },
    { id: 5, name: "User Interface improvement" },
  ];

  const onSubmit = async (data) => {
    const formattedData = {
      name: data.message,
      date4: { date: data.dateOfNeed },
      text_mkkdwa6k: data.affectUser,
      text_mkkdxhcb: data.willBenefit,
      dropdown_mkkdg2p1: {
        label: importanceOptions.find(
          (option) => option.id === parseInt(data.importantIssues)
        ).name,
      },
      type: {
        label: typeOptions.find((option) => option.id === parseInt(data.type))
          .name,
      },
    };

    try {
      setSendingMessage(true);
      const response = await fetch("api/getHelp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formattedData),
      });

      if (response.status === 403) {
        toast.error("You must be logged in to ask for help");
      }
      if (response.status === 500) {
        toast.error("500 Internal Server Error!");
      }
      if (response.status === 200) {
        toast.success("Help form submitted sucessfully.");
      }

      setSendingMessage(false);
      onHelpModalClose();
      console.log("====", response);
    } catch (error) {
      toast.error("Something went wrong!");
      setSendingMessage(false);
    }
  };

  return (
    <Box my={5}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <SimpleGrid columns={2} spacing={4}>
          <Box>
            <FormControl my={1} isInvalid={errors.dateOfNeed}>
              <FormLabel>When do you need / want this by?</FormLabel>
              <Input
                type="date"
                border="1px solid black"
                _focus={{
                  ring: "none",
                  border: "1px solid black",
                }}
                {...register("dateOfNeed", {
                  required: "This field is required",
                })}
              />
              <FormErrorMessage>{errors.dateOfNeed?.message}</FormErrorMessage>
            </FormControl>
          </Box>
          <Box>
            <FormControl my={1} isInvalid={errors.affectUser}>
              <FormLabel>
                What is the impact? How will this affect users?
              </FormLabel>
              <Input
                type="text"
                border="1px solid black"
                _focus={{
                  ring: "none",
                  border: "1px solid black",
                }}
                {...register("affectUser", {
                  required: "This field is required",
                })}
              />
              <FormErrorMessage>{errors.affectUser?.message}</FormErrorMessage>
            </FormControl>
          </Box>
          <Box>
            <FormControl my={1} isInvalid={errors.willBenefit}>
              <FormLabel>Who will benefit from this?</FormLabel>
              <Input
                type="text"
                border="1px solid black"
                _focus={{
                  ring: "none",
                  border: "1px solid black",
                }}
                {...register("willBenefit", {
                  required: "This field is required",
                })}
              />
              <FormErrorMessage>{errors.willBenefit?.message}</FormErrorMessage>
            </FormControl>
          </Box>
          <Box>
            <FormControl my={1} isInvalid={errors.importantIssues}>
              <FormLabel>How important is this issue?</FormLabel>
              <Select
                border="1px solid black"
                _focus={{
                  ring: "none",
                  border: "1px solid black",
                }}
                {...register("importantIssues", {
                  required: "Please select the importance level",
                })}
              >
                <option value="">Select importance level</option>
                {importanceOptions.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name}
                  </option>
                ))}
              </Select>
              <FormErrorMessage>
                {errors.importantIssues?.message}
              </FormErrorMessage>
            </FormControl>
          </Box>
          <Box>
            <FormControl my={1} isInvalid={errors.type}>
              <FormLabel>Type</FormLabel>
              <Select
                border="1px solid black"
                _focus={{
                  ring: "none",
                  border: "1px solid black",
                }}
                {...register("type", {
                  required: "Please select the type",
                })}
              >
                <option value="">Select type</option>
                {typeOptions.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name}
                  </option>
                ))}
              </Select>
              <FormErrorMessage>{errors.type?.message}</FormErrorMessage>
            </FormControl>
          </Box>
        </SimpleGrid>

        <FormControl isInvalid={errors.message}>
          <FormLabel>What is being requested?</FormLabel>
          <Textarea
            border="1px solid black"
            _focus={{
              ring: "none",
              border: "1px solid black",
            }}
            type="text"
            {...register("message", {
              required: "This field is required",
            })}
          />
          <FormErrorMessage>{errors.message?.message}</FormErrorMessage>
        </FormControl>

        <Box textAlign="right" mt={2}>
          <Button
            disabled={sendingMessage}
            type="submit"
            variant="primaryButton"
            width="sm"
            _hover={{
              background: "",
            }}
          >
            {sendingMessage ? "Sending....." : "Send"}
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default HelpForm;
